import React from 'react';
import { Fade } from "react-awesome-reveal";
import { Link } from 'react-scroll'
/* eslint-disable no-unused-vars */

const pricingPlans = [
    {
        name: 'Cloud',
        description: 'Getting started quickly',
        features: [
            'SAAS Watch handles hosting',
            'Subscription based pricing',
            'Standard support',
            'Core integrations'
        ],
        popular: true,
        icon: (
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                <path d="M19.5 10.5C19.5 10.5 19.5 10.5 19.5 10.5C21.433 10.5 23 12.067 23 14C23 15.933 21.433 17.5 19.5 17.5H6C3.51472 17.5 1.5 15.4853 1.5 13C1.5 10.5147 3.51472 8.5 6 8.5C6.08055 8.5 6.16066 8.50197 6.24028 8.50587C6.79516 5.6683 9.3023 3.5 12.3 3.5C15.5686 3.5 18.2374 6.0706 18.4761 9.29427C18.8086 9.35951 19.1318 9.45261 19.443 9.57137" stroke="url(#cloudGrad)" strokeWidth="2" strokeLinecap="round"/>
                <defs>
                    <linearGradient id="cloudGrad" x1="1.5" y1="3.5" x2="23" y2="17.5" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#3b82f6"/>
                        <stop offset="1" stopColor="#1d4ed8"/>
                    </linearGradient>
                </defs>
            </svg>
        )
    },
    {
        name: 'Self-Hosted',
        description: 'For advanced teams',
        features: [
            'Customer hosts the application',
            'Subscription based pricing',
            'Priority support',
            'All integrations included',
            'Custom configurations'
        ],
        popular: false,
        icon: (
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                <rect x="2" y="3" width="20" height="6" rx="1" stroke="url(#serverGrad)" strokeWidth="2"/>
                <rect x="2" y="11" width="20" height="6" rx="1" stroke="url(#serverGrad)" strokeWidth="2"/>
                <circle cx="6" cy="6" r="1" fill="url(#serverGrad)"/>
                <circle cx="6" cy="14" r="1" fill="url(#serverGrad)"/>
                <path d="M18 6H10" stroke="url(#serverGrad)" strokeWidth="2" strokeLinecap="round"/>
                <path d="M18 14H10" stroke="url(#serverGrad)" strokeWidth="2" strokeLinecap="round"/>
                <path d="M12 17V21M12 21H8M12 21H16" stroke="url(#serverGrad)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <defs>
                    <linearGradient id="serverGrad" x1="2" y1="3" x2="22" y2="21" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#3b82f6"/>
                        <stop offset="1" stopColor="#1d4ed8"/>
                    </linearGradient>
                </defs>
            </svg>
        )
    }
];

const PricingSection = () => {
    return (
        <section id="pricing" className="pricing-modern">
            <div className="container">
                {/* Section Header */}
                <div className="section-header-modern">
                    <Fade direction="down" triggerOnce={true} duration={800}>
                        <span className="section-badge">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                <path d="M12 1V23M17 5H9.5C8.57174 5 7.6815 5.36875 7.02513 6.02513C6.36875 6.6815 6 7.57174 6 8.5C6 9.42826 6.36875 10.3185 7.02513 10.9749C7.6815 11.6313 8.57174 12 9.5 12H14.5C15.4283 12 16.3185 12.3687 16.9749 13.0251C17.6313 13.6815 18 14.5717 18 15.5C18 16.4283 17.6313 17.3185 16.9749 17.9749C16.3185 18.6313 15.4283 19 14.5 19H6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            Pricing
                        </span>
                    </Fade>
                    <Fade direction="down" triggerOnce={true} duration={1000} delay={100}>
                        <h2 className="section-title">Simple, Transparent Pricing</h2>
                    </Fade>
                    <Fade direction="down" triggerOnce={true} duration={1000} delay={200}>
                        <p className="section-subtitle">
                            Choose the plan that works best for your organization. No hidden fees.
                        </p>
                    </Fade>
                </div>

                {/* Pricing Cards */}
                <div className="row justify-content-center">
                    {pricingPlans.map((plan, index) => (
                        <div key={index} className="col-12 col-md-6 col-lg-5 mb-4">
                            <Fade direction="up" triggerOnce={true} duration={1000} delay={index * 150}>
                                <div
                                    className={`pricing-card-modern hover-lift ${plan.popular ? 'popular' : ''}`}
                                    style={{
                                        height: '100%',
                                        display: 'flex',
                                        flexDirection: 'column'
                                    }}
                                >
                                    {/* Icon */}
                                    <div style={{ marginBottom: '20px' }}>
                                        {plan.icon}
                                    </div>

                                    {/* Plan Name & Description */}
                                    <h3 style={{
                                        fontSize: '1.75rem',
                                        fontWeight: '700',
                                        color: '#0c111d',
                                        marginBottom: '8px'
                                    }}>
                                        {plan.name}
                                    </h3>
                                    <p style={{
                                        fontSize: '1rem',
                                        color: '#6b7280',
                                        marginBottom: '24px'
                                    }}>
                                        {plan.description}
                                    </p>

                                    {/* Divider */}
                                    <div style={{
                                        height: '1px',
                                        background: 'linear-gradient(90deg, transparent, rgba(59, 130, 246, 0.3), transparent)',
                                        marginBottom: '24px'
                                    }}></div>

                                    {/* Features */}
                                    <h4 style={{
                                        fontSize: '0.875rem',
                                        fontWeight: '600',
                                        color: '#6b7280',
                                        textTransform: 'uppercase',
                                        letterSpacing: '1px',
                                        marginBottom: '16px'
                                    }}>
                                        Features
                                    </h4>
                                    <ul style={{
                                        listStyle: 'none',
                                        padding: 0,
                                        margin: 0,
                                        flex: 1
                                    }}>
                                        {plan.features.map((feature, fIndex) => (
                                            <li
                                                key={fIndex}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '12px',
                                                    marginBottom: '12px',
                                                    color: '#374151'
                                                }}
                                            >
                                                <span style={{
                                                    width: '20px',
                                                    height: '20px',
                                                    background: plan.popular
                                                        ? 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)'
                                                        : 'rgba(59, 130, 246, 0.1)',
                                                    borderRadius: '50%',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    flexShrink: 0
                                                }}>
                                                    <svg width="10" height="8" viewBox="0 0 10 8" fill="none">
                                                        <path
                                                            d="M1 4L3.5 6.5L9 1"
                                                            stroke={plan.popular ? 'white' : '#3b82f6'}
                                                            strokeWidth="2"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                </span>
                                                {feature}
                                            </li>
                                        ))}
                                    </ul>

                                    {/* CTA Button */}
                                    <div className="pricing-cta" style={{ marginTop: '30px' }}>
                                        <Link
                                            to="contact"
                                            spy={true}
                                            smooth={true}
                                            duration={500}
                                            offset={-100}
                                            className={plan.popular ? 'btn-gradient' : 'btn-ghost'}
                                            style={{
                                                width: '100%',
                                                cursor: 'pointer',
                                                textAlign: 'center'
                                            }}
                                        >
                                            Contact us for pricing
                                        </Link>
                                    </div>
                                </div>
                            </Fade>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default PricingSection;
